<template>
  <div class="CollapseBlockWithImage">
    <collapse-block
      ref="collapseBlock"
      :icon="icon"
      :start-expanded="startExpanded"
      :title="title"
      class="CollapseBlockWithImage-Collapse"
    >
      <div class="CollapseBlockWithImage-ContentWrapper">
        <div
          :class="{
            'CollapseBlockWithImage-Content--left': isLeft(),
            'CollapseBlockWithImage-Content--right': isRight(),
          }"
          class="CollapseBlockWithImage-Content"
        >
          <slot />
        </div>

        <div
          :class="{
            'CollapseBlockWithImage-ImageWrapper--left': isLeft(),
            'CollapseBlockWithImage-ImageWrapper--right': isRight(),
          }"
          class="CollapseBlockWithImage-ImageWrapper"
        >
          <img
            :src="imageUrl"
            :alt="imageAltText"
            class="CollapseBlockWithImage-Image"
          >
        </div>
      </div>

    </collapse-block>
  </div>
</template>

<style lang="scss" scoped>
  @import "~@/styles/_variables.scss";

  .CollapseBlockWithImage {
    &-ContentWrapper {
      display: flex;
      flex-wrap: wrap;

      @media screen and (min-width: $desktop-breakpoint) {
        flex-wrap: nowrap;
      }
    }

    &-Content {
      margin: 0;
      flex: 0 0 100%;

      @media screen and (min-width: $desktop-breakpoint) {
        flex: 0 0 50%;
        max-width: 50%;
      }

      &--left {
        order: 2;
      }

      &--right {
        order: 1;
      }
    }

    &-ImageWrapper {
      margin: 0;
      flex: 0 0 100%;
      overflow: hidden;
      max-height: 70vh;

      @media screen and (min-width: $desktop-breakpoint) {
        position: sticky;
        top: 50px;
        flex: 0 0 50%;
        max-width: 50%;
      }

      &--left {
        order: 1;
      }

      &--right {
        order: 2;
      }
    }

    &-Image {
      object-fit: cover;
      object-position: center;
      height: 100%;
      width: 100%;
      max-height: 100vh;

      @media screen and (min-width: $desktop-breakpoint) {
        max-height: 70vh;
      }
    }
  }
</style>

<script>
  import CollapseBlock from '@/components/CollapseBlock.vue';

  export default {
    components: {
      CollapseBlock,
    },

    props: {
      icon: {
        type: String,
        default: null,
      },

      title: {
        type: String,
        required: true,
      },

      imageUrl: {
        type: String,
        default: "/img/background-business-people.jpg",
      },

      imageAltText: {
        type: String,
        default: "A imagem apresenta um grupo de pessoas de negócios em uma sala de reuniões, com uma mulher em primeiro plano",
      },

      startExpanded: {
        type: Boolean,
        default: false,
      },

      side: {
        type: String,
        default: "left",
        validator: function(value) {
          return ["left", "right"].indexOf(value) !== -1;
        },
      },
    },

    methods: {
      isLeft() {
        return this.side == "left";
      },

      isRight() {
        return this.side == "right";
      },

      expand() {
        return this.$refs.collapseBlock.expand();
      },

      shrink() {
        return this.$refs.collapseBlock.shrink();
      },
    },
  };
</script>
